<template>
  <div class="my-5 mx-0 px-4 editBG"  style="border-top: solid 1px;">
    <h2 class="mt-3 mx-2">Create a Todo </h2>
    <v-layout row wrap class="mx-0 mt-0 px-0 pt-2 mb-4">

      <!-- // TITLE -->
      <v-flex xs12 md6 p-2>
        <v-text-field
          v-model="todo.title"
          class="ml-2"
          name="description"
          label="Description *"
        ></v-text-field>
      </v-flex>

      <!-- // DEADLINE -->
      <v-flex xs12 sm6 md3 px-2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :return-value.sync="todo.deadline"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :nudge-right="0"
          lazy
        >
          <v-text-field
            slot="activator"
            v-model="todo.deadline"
            prepend-inner-icon="event"
            readonly
            label="Deadline"
          ></v-text-field>
          <v-date-picker
            :min="format_date(Date.now())"
            color="black"
            v-model="todo.deadline"
            @input="$refs.menu2.save(todo.deadline)"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <!-- // REMINDER -->
      <v-flex xs12 sm6 md3 pl-1 pr-2>
          <!-- :disabled="todo.deadline == ''" -->
        <v-menu
          ref="menu3"
          v-model="menu3"
          :return-value.sync="todo.reminder"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :nudge-right="30"
          lazy
          landscape
        >
            <!-- :disabled="todo.deadline == ''" -->
          <v-text-field
            slot="activator"
            v-model="todo.reminder"
            prepend-inner-icon="event"
            readonly
            label="Reminder"
          ></v-text-field>
          <v-date-picker
            color="black"
            :min="format_date(Date.now())"
            scrollable
            v-model="todo.reminder"
            @input="$refs.menu3.save(todo.reminder)"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <!-- description -->
      <v-flex xs12>
        <v-textarea
          auto-grow box
          rows="1"
          v-model="todo.description"
          class="mx-2 my-0"
          name="note"
          label="Note"
        ></v-textarea>
      </v-flex>

      <!-- users -->
      <!-- <v-flex pl-2 xs12> -->
        <v-flex xs12 px-2>
          <v-autocomplete
            prepend-inner-icon="person"
            background-color="grey lighten-2"
            v-model="todo.user_ids"
            :items="team_d"
            chips box clearable multiple deletable-chips
            label="Assigned to"
            item-text="abb"
            item-value="id"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                color="white"
                close small 
                class="chip--select-multi"
                @input="remove(data.item)"
              >
                <v-avatar color="black">
                  <span class="white--text">{{data.item.abb}}</span>
                  <!-- <img src="http://www.tb-cms.org/simone3.jpg"> -->
                </v-avatar>
                {{ data.item.firstname }} {{ data.item.lastname }}
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <v-icon>person</v-icon>
                  <!-- <span class="white--text headline">{{data.item.abb}}</span> -->
                  <!-- <img src="http://www.tb-cms.org/simone3.jpg"> -->
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ data.item.abb }} - {{ data.item.firstname }} {{ data.item.lastname }}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.id"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>

        <!-- REPEAT -->
        <v-flex xs12 sm6 md3 mt-2 >
            <!-- style="width:100px;" -->
          <v-text-field
            v-model="todo.frequency"
            class="ml-2 xs2"
            name="frequency"
            label="Repeat every …"
            prepend-inner-icon="loop"
            hide-details
          ></v-text-field>
          <div v-if="todo.repeat" class="pl-2 red--text">Must be filled!</div>
        </v-flex>

        <!-- repeat buttons -->
        <v-flex xs12 sm6 md3 mt-4 ml-3>
          <v-btn-toggle v-model="todo.repeat" class="mt-0" small>
            <!-- <v-toggle-button v-model="todo.repeat" class="xs8 sm6 pb-2 ml-3 row"> -->
            <v-btn flat small key="group1" class="px-3" input-value="day" value="day">
              <span>Days</span>
            </v-btn>
            <v-btn flat small key="group2" class="px-3" input-value="month" value="month">
              <span>Months</span>
            </v-btn>
            <v-btn flat small key="group3" class="px-3" input-value="year" value="year">
              <span>Years</span>
            </v-btn>
            <!-- <v-btn value="day" label="Days" key="day"></v-btn>
            <v-btn value="month" label="Months" key="month"></v-btn>
            <v-btn value="year" label="Years" key="year"></v-btn>-->
          </v-btn-toggle>
        </v-flex>
      <!-- </v-flex> -->
      <!-- </v-flex> -->

      <!-- selected_artworks -->
      <v-flex pl-2 mt-3 xs12>
          <v-autocomplete
            v-model="selected_artworks"
            :search-input.sync="search"
            prepend-inner-icon="photo_library"
            background-color="grey lighten-2"
            color="black"
            chips box clearable multiple deletable-chips
            :items="artworks"
            :item-text="
              item =>
                item.title +
                ', ' +
                item.accession_number +
                ', ' +
                item.name
            "
            item-value="id"
            label="Select Artworks related to this Todo *"
            menu-props='{"closeOnClick":true, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
          >
            <!-- prepend-icon="filter_list" -->
            <!-- <template v-slot:item="data">
              <div
                :key="data.item.id"
                :selected="data.selected"
                :disabled="data.disabled"
                @input="data.parent.selectItem(data.item)"
              >
              <v-checkbox value="data.item.selected"></v-checkbox>
                {{ data.item.title }}
              </div>
            </template> -->
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close small
                class="chip--select-multi white--text chip--select-multi"
                color="black"
                @input="remove_artwork(data.item)"
              >
                <strong v-html="data.item.title"></strong>&nbsp;
                <span>{{ data.item.accession_number }} </span>&nbsp;
                <strong
                  v-html="
                    data.item.artist
                      ? data.item.artist.name
                      : data.item.name
                  "
                ></strong>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong v-html="data.item.title"></strong>&nbsp;
                  <span>{{ data.item.accession_number }} </span>&nbsp;
                  <strong v-html="data.item.name"></strong>
                </v-list-tile-title>
                <v-list-tile-sub-title></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>

          </v-autocomplete>
        </v-flex>

        <!-- </v-layout>
        </v-container>-->
        <!-- </v-flex>

        <v-flex xs12 md6 mt-0 pr-3 layout>-->

        <!-- <h3 class="ml-3">When done, notify:</h3> -->

        <!-- <v-container xs12 ml-0 pt-0 mt-0>
        <v-layout wrap>-->
        <!-- <v-flex xs12 lg6>
          <v-autocomplete
            v-model="todo.notify"
            :items="team_d"
            chips
            color="blue-grey lighten-2"
            label="When done, notify …"
            prepend-icon="person"
            item-text="abb"
            item-value="id"
            multiple
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                close small 
                class="chip--select-multi"
                @input="remove(data.item)"
              >
                <v-avatar color="black">
                  <span class="white--text">{{data.item.abb}}</span>
                </v-avatar>
                <v-list-tile-content>
                  <v-list-tile-title> {{ data.item.firstname }} {{ data.item.lastname }}</v-list-tile-title>
                </v-list-tile-content>
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <span class="white--text headline">{{data.item.abb}}</span>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title> {{ data.item.firstname }} {{ data.item.lastname }}</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>-->
      </v-flex>

      <v-flex class="xs12 layout my-2">
        <v-spacer></v-spacer>
        <v-btn @click="" small flat class="mb-3">cancel</v-btn>
        <!-- <v-btn @click="save_todo" small dark v-if="selected_artworks.length == 0">create todo</v-btn> -->
        <v-btn class="white--text" @click="save_todo" small color="black" :disabled="selected_artworks.length == 0 || todo.title == ''">create todo for selected artworks</v-btn>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
  import constants from '@/data/constants'
  import { serverBus } from '../../main'
  import axios from 'axios'
  export default {
    data () {
      return {
        selected_artworks: [],
        search: '',
        menu3: false,
        todo: {
          related_todo_id: '',
          description: '',
          title: '',
          deadline: '',
          reminder: '',
          done: false,
          done_at: '',
          repeat: '',
          user_ids: [],
          notify: []
        },
        constants: constants,
        data: false,
        menu2: false,
        valid: true,
        menu: false,
        modal: false,
        autosave: true,
        result: '',
        approved: true,
      }
    },
    methods: {
      remove (item) {
        const index = this.todo.user_ids.indexOf(item.id)
        if (index >= 0) this.todo.user_ids.splice(index, 1)
      },
      remove_artwork (item) {
        const index = this.selected_artworks.indexOf(item.id)
        if (index >= 0) this.selected_artworks.splice(index, 1)
      },
      new_todo () {
        this.editing = false
        this.todo.deadline = '' // this.format_date(Date.now())
        this.todo.reminder = '' // this.format_date(Date.now())
        this.todo.user_ids = []
        this.todo.user_ids.push(this.c_user.id)
        this.todo.notify = []
        this.todo.notify.push(this.c_user)
        this.todo.created_by = this.c_user.id
      },
      async save_todo () {
        serverBus.$emit('showSnackbar', 'Adding new Todo …')
        var related_todo_id = Number
        this.todo.done = 0
        this.todo.created_by = this.c_user.id
        if (this.selected_artworks.length > 0) {
          for(var a in this.selected_artworks) {
            // SAVING NEW TODO
            this.todo.artwork_id = this.selected_artworks[a]
            if (related_todo_id > 0){
              this.todo.related_todo_id = related_todo_id
            }
            // this.$store.dispatch('saveTodo', this.editing)
            await axios
              .post(`${this.$globals.apiserver}/artwork_todos.json`, {
                todo: this.todo
              })
              .then(response => {
                serverBus.$emit('showSnackbar', 'Todo saved.', 'green')
                this.errors = {}
                //console.log(response)
                // this.active_todos = this.artwork.artwork_todos
                this.$store.dispatch('loadTodos')
                related_todo_id = response.data.id
                // this.active_todos.push(response.data);
                // this.todos.push(response.data)
              })
              .catch(error => {
                serverBus.$emit('showSnackbar', 'Problem occured while saving Todo. Try again or contact support.')
                this.errors = error.response.data
              })
          }
          this.$store.dispatch('loadTodos')
          this.todo = {
            related_todo_id: '',
            description: '',
            title: '',
            deadline: '',
            done: 0,
            done_at: '',
            team: [],
            notify: ''
          }
        }
      }
    },
    computed: {
      team_d () {
        var f = Object.assign(this.$store.state.users)
        return f.filter(u => u.enable == 'Y' && u.edit == 1)
      },
      artworks() {
        return Object.assign([], this.$store.state.artworks);
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/todos/AddTodo.vue